import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPalette,
  faMoon,
  faSun,
  faLanguage,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { useDarkMode } from "../../contexts/ThemeContext";

function AppearanceSection({ darkMode, t }) {
  const { i18n } = useTranslation();
  const { toggleDarkMode } = useDarkMode();

  const changeLang = (e) => {
    const lang = e.target.value;
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
  };

  return (
    <>
      <div className="profile-section">
        <div className="profile-section-header">
          <div className="profile-section-icon">
            <FontAwesomeIcon icon={faPalette} />
          </div>
          <div>
            <h2 className="profile-section-title">{t("Appearance")}</h2>
            <p className="profile-section-desc">
              {t("Customize how VRTTA looks")}
            </p>
          </div>
        </div>

        <div className="profile-setting">
          <div className="profile-setting-left">
            <div className="profile-setting-icon theme">
              <FontAwesomeIcon icon={darkMode ? faMoon : faSun} />
            </div>
            <div className="profile-setting-info">
              <h4>{t("Dark Mode")}</h4>
              <p>{t("Reduce eye strain in low-light environments")}</p>
            </div>
          </div>
          <label className="profile-toggle">
            <input
              type="checkbox"
              checked={darkMode}
              onChange={toggleDarkMode}
            />
            <span className="profile-toggle-track">
              <span className="profile-toggle-thumb" />
            </span>
          </label>
        </div>
      </div>

      <div className="profile-section">
        <div className="profile-section-header">
          <div className="profile-section-icon">
            <FontAwesomeIcon icon={faLanguage} />
          </div>
          <div>
            <h2 className="profile-section-title">{t("Language")}</h2>
            <p className="profile-section-desc">
              {t("Choose your preferred language")}
            </p>
          </div>
        </div>

        <div className="profile-form-group" style={{ maxWidth: 280 }}>
          <label className="profile-label">{t("Display Language")}</label>
          <div className="profile-select-wrap">
            <select
              className="profile-select"
              value={i18n.language}
              onChange={changeLang}
            >
              <option value="en">English</option>
              <option value="fr">Français</option>
            </select>
            <span className="profile-select-arrow">
              <FontAwesomeIcon icon={faChevronDown} />
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default AppearanceSection;
